import { Injectable, signal } from '@angular/core';

type ProfileLike = {
  displayName?: string;
  givenName?: string;
  surname?: string;
  jobTitle?: string;
  [key: string]: unknown;
};

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public UserObj = signal<{
    user?: ProfileLike;
    role?: number;
    modules?: string[];
    setting_modules?: string[];
    [key: string]: unknown;
  }>({
    user: {},
  });

  /** True when the signed-in user has the Entra `Editors` app role. */
  readonly isEditor = signal(false);

  setIsEditor(value: boolean): void {
    this.isEditor.set(value);
  }

  setUserAuthData(partial: Record<string, unknown>): void {
    this.UserObj.update((current) => ({ ...current, ...partial }));
  }
}
